import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import { useGetRegularReleaseList } from '../../hooks';

export const RegularReleaseSelect = ({
  placeholder = 'Full/Release Value',
  label = 'Enter Full/Release Value',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetRegularReleaseList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      shouldUseNativeSelect
    />
  );
};
